import React, { useEffect, useState } from 'react';
import Nav from '../../components/Nav/Nav';
import DashboardNav from '../../components/Nav/DashboardNav';
import ratedPeople from '../assets/rating_header.png';
import smallRatedPeople from '../assets/rating_header.png';
import Footer from '../../components/Footer/Footer';
import aboutImage from './Assets/about.png';
import aboutClient from './Assets/about-client.jpg';
import aboutVendor from './Assets/about-vendor.jpg';
import { useNavigate } from 'react-router-dom';
import { Handshake } from "lucide-react";
import { Lightbulb } from "lucide-react";
import StarRating from '../../components/Starrating';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import { jwtDecode } from 'jwt-decode';



const About = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null)

    function decodeData(data) {
        return atob(data); // Base64 encoding
    }

    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {
            setUser(userInfo?.user)
        }
    }, [setUser])

    return (
        <div className='overflow-x-hidden '>

            {user ?
                <DashboardNav /> : <Nav />}


            <div className='relative  w-full flex flex-col gap-[50px] bg-custom-gradient h-[557px] md:h-[345px] lg:h-[447px] xl:h-[595px] '>
                <div className='  '>

                    <div className='  flex flex-col items-center  md:items-start text-center md:justify-end md:flex-row gap-[30px]'>
                        <img src={aboutImage} alt="smallRatedPeople" className='absolute bottom-0 md:left-0  h-auto sm:w-[540px] md:w-[51%] lg:w-[55%] xl:w-[58%]' />
                        <div className='absolute w-full top-[124px] md:top-[146px] md:right-[40px] lg:right-[66px] lg:top-[195px] xl:top-[219px] xl:right-[64px] flex flex-col gap-2 text-white text-center sm:items-center md:items-start md:mt-[0px] md:w-[340px]  lg:w-[464px] xl:w-[664px] md:text-start pt-[0px]'>

                            {/* <h1 className=' w-full font-black text-center md:text-start px-[24px] md:px-0 text-xl lg:text-huge xl:text-hb'>See what others are saying about your favourite vendors</h1>
              <p className=' font-medium text-sm mg:text-lg px-[49px] md:px-0 '>Discover honest, unbiased reviews to help you make informed choices.</p> */}
                            <h1 className='w-3/4 mx-auto md:mx-0 md:w-full leading-[32px] tracking-[-0.02em] font-black text-center md:text-start  md:px-0 text-[24px] lg:text-big xl:text-[40px] xl:text-hb'>
                                Expand your reach. <br></br> Connect with real customers
                            </h1>
                            <p className='font-medium text-sm xl:text-lg px-8 md:px-0'>
                                Discover honest and unbiased reviews that
                                help you make informed choices

                            </p>
                            <div className="flex w-full sm:w-fit md:w-full xl:w-fit gap-[6px] md:gap-2 justify-center  mt-5 px-7 md:px-0 md:mt-1 xl:mt-8 ">
                                <button onClick={() => navigate('/signup')} className=" w-full h-[42px] border border-white whitespace-nowrap flex justify-center items-center  font-bold text-white px-4 py-2  rounded-[80px] text-[16px] xl:px-11">List a vendor</button>
                                <button onClick={() => navigate('/')} className="w-full bg-ravblue  flex justify-center items-center h-[42px] whitespace-nowrap font-medium text-white px-4 py-2 rounded-[80px] text-[16px] xl:px-11">Find vendors</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='px-6 md:px-8 mb-[45px]'>
                <section className='mt-8 flex gap-5 md:gap-[60px] lg:gap-[140px] items-center justify-center '>
                    <div className='p-[10px]  flex flex-col items-center  '>
                        <h1 className='text-[#FEAD00] font-black text-[24px] lg:text-huge xl:text-huger'>1,000+</h1>
                        <p className='text-sam font-medium'>Vendors</p>
                    </div>
                    <div className='p-[10px] flex flex-col items-center '>
                        <h1 className='text-[#FEAD00] font-black text-[24px] lg:text-huge xl:text-huger'>100+</h1>
                        <p className='text-sam font-medium'>Reviews</p>
                    </div>
                    <div className='p-[10px]  flex flex-col items-center text-center  '>
                        <h1 className='text-[#FEAD00] font-black text-[24px] lg:text-huge xl:text-huger'>3</h1>
                        <p className='text-sam font-medium'>Countries</p>
                    </div>

                </section>

                <section className='  flex flex-col gap-[10px] items-center text-center   lg:px-[127px] xl:px-[64px] mt-[51px] md:mt-[54px] lg:mt-[81px] mb-[80px] xl:mb-[78px] '>
                    <h1 className='font-black text-xl md:text-huge '>Why Rate A Vendor</h1>
                    <p className='w-[90%] font-medium xl:w-1/2 '><span className='font-bold'>Empowering Better Event Experiences  and Growing Vendor Visibility: </span>
                        At
                        RateAVendor, we believe every event
                        deserves excellence - from the smallest
                        backyard celebration to the grandest
                        wedding or corporate gala. We exist to
                        make vendor selection transparent,
                        trustworthy, and effortless for clients,
                        while giving vendors the visibility,
                        credibility, and bookings they need to
                        grow their business.</p>
                </section>

                <div
                    className="mt-28 md:mt-[71px] w-full   rounded-t-[30px] relative  h-[621px]  md:h-[253px] lg:h-[209px] xl:h-[343px]   "
                    style={{
                        background:
                            "linear-gradient(180deg, #FFDDA9 0%, rgba(255, 221, 169, 0) 100%)",
                    }}
                >

                    {/* 📝 Text + Button Section */}
                    <div className=" absolute   grid grid-cols-1 md:grid-cols-3 text-center  xl:gap-x-[100px]  items-start  md:mt-0 inset-x-8    md:inset-y-12  md:inset-x-2  lg:inset-y-[34px] xl:inset-y-[55px] lg:inset-x-[42px] lg:inset-x-[166px]">
                        <div className="flex flex-col gap-[10px] font-bold items-center text-center pt-8 md:pt-0 h-full justify-start md:px-3">


                            <span class="flex items-center justify-center h-9 w-9 rounded-full bg-ravblue text-sm font-black text-white">
                                1
                            </span>

                            <p className="text-sm font-black  lg:whitespace-nowrap ">
                                Find Trusted Vendors with Ease
                            </p>

                            <p className="text-[14px] font-medium ">
                                <span className="block lg:inline">
                                    Discover verified and highly rated
                                    vendors for any service, all in one place.
                                </span>
                            </p>
                        </div>
                        <div className="flex flex-col gap-[10px] font-bold items-center text-center pt-8 md:pt-0 h-full justify-start md:px-2">


                            <span class="flex items-center justify-center h-9 w-9 rounded-full  bg-ravblue text-sm font-black text-white">
                                2
                            </span>

                            <p className="text-sm font-black lg:whitespace-nowrap ">
                                Make Confident Choices
                            </p>

                            <p className="text-[14px] font-medium ">
                                <span className="block lg:inline">
                                    Read real reviews and ratings from
                                    other users before you book, so you
                                    always know who to trust.
                                </span>
                            </p>
                        </div>
                        <div className="flex flex-col gap-[10px] font-bold items-center text-center pt-8 md:pt-0 h-full justify-start">


                            <span class="flex items-center justify-center h-9 w-9 rounded-full  bg-ravblue text-sm font-black text-white">
                                3
                            </span>

                            <p className="text-sm font-black  lg:whitespace-nowrap ">
                                Grow Your Business Reputation
                            </p>

                            <p className="text-[14px] font-medium ">
                                <span className="block lg:inline">
                                    Vendors can showcase their services,
                                    earn reviews, and reach new clients
                                    faster.
                                </span>
                            </p>
                        </div>

                    </div>
                </div>

                <section className='  grid grid-cols-1 md:grid-cols-2 gap-[45px] md:gap-[28px] lg:gap-[100px] items-start  text-start  mt-16  lg:mt-[79px] xl:mt-[108px] mb-[80px] md:mb-0 '>
                    <div className='flex flex-col flex-1 gap-[10px]'>
                        <h1 className='font-black text-xl xl:text-xxl '>For Vendors: Visibility,
                            Bookings, and Growth</h1>
                        <p className=' font-medium'>
                            We understand that many talented vendors
                            struggle to be seen. The event industry is
                            competitive, and often, only the big
                            players dominate visibility and booking
                            opportunities. That's where RateAVendor
                            comes in.
                        </p>
                        <p className=' font-medium '>

                            Our platform gives every vendor an equal
                            opportunity
                            to shine by helping you:.</p>
                        <div className='space-y-4 mt-4'>
                            <div class="flex items-baseline space-x-[10px]">
                                <span class=" inline-block h-3 w-3 rounded-full bg-ravblue shrink-0 "></span>
                                <span>Increase visibility to clients actively searching for your services</span>
                            </div>
                            <div class="flex items-baseline space-x-[10px]">
                                <span class=" inline-block h-3 w-3 rounded-full bg-ravblue shrink-0 "></span>
                                <span>Convert trust into bookings through
                                    verified reviews and authentic client
                                    feedback.</span>
                            </div>
                            <div class="flex items-baseline space-x-[10px]">
                                <span class=" inline-block h-3 w-3 rounded-full bg-ravblue shrink-0 "></span>
                                <span>Build credibility and grow your brand
                                    reputation with every satisfied customer.</span>
                            </div>
                        </div>
                    </div>


                    <div className='lg:mr-[49px] md:mt-[44px] md:mb-[67px] xl:mb-0 xl:mt-0 '>
                        <img className='w-auto h-auto  rounded-[20px]' src={aboutClient} alt='clients' />
                    </div>

                </section>




                <section className='  flex flex-col md:flex-row-reverse  md:items-end gap-[45px] md:gap-7 lg:gap-[58px] items-start text-start lg:items-end xl:items-start mt-16 md:-mt-[6vh] lg:mt-0 xl:mt-[80px]  mb-[80px] '>
                    <div className='flex flex-col flex-1 gap-[10px]'>

                        <h1 className='font-black text-xl xl:text-xxl'>For Clients: Confidence through Community</h1>
                        <p className=' font-medium'>
                            With the rise of online vendors, finding
                            reliable event professionals can feel like
                            a gamble. Beautiful photos and bold
                            promises don't always guarantee great
                            service. That's why we created
                            RateAVendor, a space where real people
                            share real experiences.

                        </p>
                        <p className=' font-medium '>
                            Our platform empowers clients to:
                        </p>
                        <div className='space-y-4 mt-4'>
                            <div class="flex items-baseline space-x-[10px]">
                                <span class=" inline-block h-3 w-3 rounded-full bg-ravblue shrink-0 "></span>
                                <span>Increase visibility to clients actively searching for your services</span>
                            </div>
                            <div class="flex items-baseline space-x-[10px]">
                                <span class=" inline-block h-3 w-3 rounded-full bg-ravblue shrink-0 "></span>
                                <span>Convert trust into bookings through
                                    verified reviews and authentic client
                                    feedback.</span>
                            </div>
                            <div class="flex items-baseline space-x-[10px]">
                                <span class=" inline-block h-3 w-3 rounded-full bg-ravblue shrink-0 "></span>
                                <span>Build credibility and grow your brand
                                    reputation with every satisfied customer.</span>
                            </div>
                        </div>

                    </div>
                    <div className='flex-1 lg:ml-[49px] md:mb-[27px] xl:mb-0'>
                        <img className='w-auto h-auto rounded-[20px] ' src={aboutVendor} alt='vendors' />
                    </div>


                </section>


                <section className=' flex flex-col  gap-[21px]  mt-[108px] lg:mt-[149px] xl:mt-[139px] mb-[175px] justify-center '>

                    <div className=' mb-[12px]  flex flex-col gap-[6px] items-center text-center  '>

                        <h1 className='font-black text-xl xl:text-huge '>Our commitment to a Better Service</h1>
                        <p className='w-[90%] font-medium text-sm'>
                            Building the future together.</p>
                    </div>
                    <div className=' md:flex md:flex-row md:gap-[30px] lg:gap-[60px] xl:gap-0 md:gap-4 items-center justify-center '>

                        <div className='py-[10px] px-[17px] flex flex-col gap-[10px] items-center text-center xl:w-2/5 xl:px-[56px]'>
                            <Lightbulb className="w-8 h-8 text-ravblue" />
                            <h1 className='font-black text-sm '>Our Vision</h1>
                            <p className='w-[90%] font-medium text-base'>
                                A world where trust drives every booking
                                - where clients find confidence in authenticity,
                                and vendors grow through the power of
                                proven quality.</p>
                        </div>

                        <div className='  py-[10px] px-[17px] flex flex-col gap-[10px] items-center text-center xl:w-2/5 xl:px-[56px] '>
                            <Handshake className="w-8 h-8 text-ravblue" />
                            <h1 className='font-black text-sm '>Our Promise</h1>
                            <p className='w-[90%] font-medium text-base'>
                                We're more than a rating platform; we're
                                a community of accountability, growth, and
                                opportunity. Whether you're booking or being
                                booked, RateAVendor connects you to success
                                through transparency and trust.</p>
                        </div>
                    </div>


                </section>

                <section className='bg-[#DDF4FF] -mx-6  px-6 md:px-[34px]   py-14 flex flex-col gap-[38px]  mt-[108px] mb-[175px] '>

                    <div className=' flex flex-col gap-[6px] items-start md:items-start text-center md:text-start '>

                        <h1 className='font-black text-xl xl:text-xxl'>What people say about us</h1>
                        <p className='w-[90%] font-medium text-sm text-start'>
                            See How We're Making a Difference</p>
                    </div>



                    <div className='  grid grid-cols-1 md:grid-cols-2 gap-[10px] md:gap-9 text-start '>


                        <div className=' flex flex-col gap-[10px] text-start '>

                            <StarRating rating={5} />


                            <h1 className='font-medium text-sm '>Rateavendor put my brand out there. I got a few followers through the Rateavendor vendor spotlight feature and someone booked me beacuse of that. She had been wanting to book me but thought she might be scammed since
                                she hasn't worked with me before, but as she saw the vendor feature she booked my service.  </h1>
                            <div>
                                <p className=' font-black text-sm'>
                                    Pearl Akrumah </p>
                                <a href='https://www.instagram.com/pearly_eventsndecor/' className='text-ravblue font-medium underline'>Pearly_eventsndecor</a>
                            </div>
                        </div>
                    </div>

                </section>



                <div
                    className="mt-28 md:mt-[79px] w-full   rounded-t-[30px] relative  h-[340px] sm:h-[360px] md:h-[253px] "
                    style={{
                        background:
                            "linear-gradient(180deg, #FFDDA9 0%, rgba(255, 221, 169, 0) 100%)",
                    }}
                >



                    {/* 📝 Text + Button Section */}
                    <div className=" absolute  place-center inset-0 flex-col justify-center text-center  md:mt-0  items-center  ">
                        <div className="font-bold text-center  pt-8 md:px-7 lg:pt-10 space-y-[10px]">
                            <p className="text-[22px]  px-5  md:text-[24px] ">
                                Ready to find your perfect
                                vendor?
                            </p>

                            <p className="text-[14px] font-medium ">
                                <span className="block w-[70%] lg:w-[50%] mx-auto ">
                                    Join thousands of businesses who
                                    trust our platform to make informed
                                    vendor decisions
                                </span>
                            </p>
                        </div>
                        <div className='flex flex-col md:flex-row justify-center items-center gap-2 md:mt-5'>
                            <button
                                onClick={() => navigate("/")}
                                className="w-fit bg-ravblue text-white text-sm font-bold px-5 lg:px-8 py-3 rounded-[80px] mt-6 md:mt-0 "
                            >
                                Search vendors
                            </button>
                            <button
                                onClick={() => navigate("/signup")}
                                className="w-fit border border-ravblue text-ravblue text-sm font-bold px-5 py-3 lg:px-8 rounded-[80px] "
                            >
                                Join as a vendor
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div >

    )
}

export default About
